module.exports = __webpack_public_path__ + "img/c07_unittechchiefchampion_Normal_ua.ae05a958.webp";